export enum TelcoTypeEnum {
    internet = 'Pack internet',
    fixe = 'Ligne fixe',
    mobilePostpaid = 'Mobile',
    open = 'Pack internet + mobile',
    obs = 'Contrat entreprise',
    pro = 'Contrat professionnel',
}
